import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";

const CoursesProgress = ({
  totalCoursesProgress = 0,
}) => {
  const progress = Math.max(0, Math.min(100, Number(totalCoursesProgress)));

  return (
    <Box
      sx={{
        background: "#2563EB",
        borderRadius: 3,
        padding: 3,
        color: "#fff",
        boxShadow: "0px 8px 25px rgba(0,0,0,0.1)",
        width : "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Header Row */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            textAlign: "left",
          }}
        >
          Course Progress
        </Typography>
        <MenuBookOutlinedIcon sx={{ color: "#fff", fontSize: "20px" }} />
      </Box>

      {/* Percentage */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          fontSize: "32px",
          mb: "14px",
          textAlign: "left",
          lineHeight : 1,
        }}
      >
        {progress.toFixed(0)}%
      </Typography>

      {/* Completed text */}
      {/* <Typography
        variant="body2"
        sx={{
          opacity: 0.9,
          fontSize: "14px",
          mb: 1.5,
          textAlign: "left",
        }}
      >
        {totalCourses} Total Courses
      </Typography> */}

      {/* Progress Bar */}
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height : 8,
          borderRadius: 5,
          backgroundColor: "#BFDBFE ",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#ffffff",
          },
        }}
      />
    </Box>
  );
};

export default CoursesProgress;

